import { pagesPath } from "app/lib/$path";

export const useReloadApp = () => {
  return () => {
    if (window.location.href === pagesPath.$url().pathname)
      window.location.reload();
    else window.location.href = pagesPath.$url().pathname;
  };
};
